export enum Authority {
  AIR_VISIBILITY = 'AIR_VISIBILITY',
  LTL_VISIBILITY_UI = 'LTL_VISIBILITY_UI',
  OCEAN_VISIBILITY_UI = 'OCEAN_VISIBILITY_UI',
  ORDER_VISIBILITY_UI = 'ORDER_VISIBILITY_UI',
  PARCEL_VISIBILITY_UI = 'PARCEL_VISIBILITY_UI',
  PERM_FLET_LMTD = 'PERM_FLET_LMTD',
  PORTAL_LTL_RATE_QUERY = 'PORTAL_LTL_RATE_QUERY',
  PORTAL_VLTL_RATE_QUERY = 'PORTAL_VLTL_RATE_QUERY',
  RAIL_VISIBILITY_API = 'RAIL_VISIBILITY_API',
  ROLE_P44ADMIN = 'ROLE_P44ADMIN',
  AUTHORIZATION_ADMIN = 'AUTHORIZATION_ADMIN',
  SAVE_USER_ROLES = 'SAVE_USER_ROLES',
  SLOT_BOOKING_SUPPLYSTACK = 'SLOT_BOOKING_SUPPLYSTACK',
  TL_VISIBILITY_API = 'TL_VISIBILITY_API',
  TL_VISIBILITY_UI = 'TL_VISIBILITY_UI',
  VIEW_OCEAN_INSIGHTS_CSS = 'VIEW_OCEAN_INSIGHTS_CSS',
  VIEW_OCEAN_INSIGHTS_CTT = 'VIEW_OCEAN_INSIGHTS_CTT',
  VIEW_OCEAN_REPORTS = 'VIEW_OCEAN_REPORTS',
  VIEW_PORT_INTEL = 'VIEW_PORT_INTEL', // Remove as part of AMI-1289
  VIEW_REPORTS = 'VIEW_REPORTS',
  VIEW_USER_ROLES = 'VIEW_USER_ROLES',
  VIEW_VOC2_ANALYTICS_HOME = 'VIEW_VOC2_ANALYTICS_HOME', // Remove as part of AMI-1289
  VIEW_VOC2_ANALAYTICS_HOME = 'VIEW_VOC2_ANALAYTICS_HOME', // Remove as part of AMI-1289
  VIEW_VOC2_OCEAN_ANALYTICS_DASHBOARD = 'VIEW_VOC2_OCEAN_ANALYTICS_DASHBOARD', // Remove as part of AMI-1289

  // Analytics permissions
  ANALYTICS_OCEAN_SUSTAINABILITY = 'VIEW_OCEAN_SUSTAINABILITY',
  ANALTYICS_ROOT_CAUSE_ANALYSIS = 'VIEW_TL_TRACKING_REPORT',
  // @todo why the duplicate value?
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  ANALYTICS_PORT_INTEL = 'VIEW_PORT_INTEL',
  // @todo why the duplicate value?
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  ANALYTICS_OCEAN = 'VIEW_VOC2_OCEAN_ANALYTICS_DASHBOARD',
  ANALYTICS_TRUCKLOAD = 'read:truckload_analytics',
  ANALYTICS_LTL = 'read:ltl-tracking-analytics',
  // @todo why the duplicate value?
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  ANALYTICS_VOC_USERS = 'VIEW_REPORTS', // Special permission based on product users coming from VOC

  // P44OS permissions
  P44OS_STANDARD_PERMISSION = 'system-admin:read:p44-os-dashboards-standard',
  P44OS_OPS_PERMISSION = 'system-admin:read:p44-os-dashboards-ops',
  P44OS_LEAD_PERMISSION = 'system-admin:read:p44-os-dashboards-lead',
  P44OS_EXEC_PERMISSION = 'system-admin:read:p44-os-dashboards-exec',

  // Initiate permissions
  // @todo why the duplicate values?
  INITIATE_CREATE_RATED_SHIPMENTS = 'create:truckload-rated-shipments-and-quotes',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  INITIATE_READ_RATED_SHIPMENTS = 'create:truckload-rated-shipments-and-quotes',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  INITIATE_UPDATE_RATED_SHIPMENTS = 'create:truckload-rated-shipments-and-quotes',

  // Network permissions
  NETWORK_READ_DIRECTORY_CARRIERS = 'read:network-directory-carriers',
  NETWORK_READ_CARRIER_MANAGEMENT = 'read:internal-carrier-identifiers',
  NETWORK_READ_HEALTH_DASHBOARD = 'read:network-health-tl-dashboards',
}
